import { appStoreLenses } from 'root/src/client/logic/app/lenses'
import providers from 'root/src/shared/constants/providers'

export default (state) => {
	const { viewYoutubeData, viewTiktokData } = appStoreLenses
	const youtubeFollowers = viewYoutubeData(state)?.followerCount ?? 0
	const tiktokFollowers = viewTiktokData(state)?.followerCount ?? 0
	return {
		[providers.youtube]: youtubeFollowers,
		[providers.tiktok]: tiktokFollowers,
		[providers.any]: Math.max(youtubeFollowers, tiktokFollowers),
	}
}
